import {
  localList,
  localOrigin,
  LOCAL_API,
  laneOrigin,
  ULP_API,
  LANE_API,
  testOrigin,
} from '../config';
import { getEnv } from './get-env';
import { EnvType } from '../mask';

type Options = {
  ulpOrigin: string;
  env?: EnvType;
  authUrl?: string;
  needGetUlpToken?: boolean;
  loginPath?: string;
};

export const getEncodedUrl = () => {
  const { origin } = window.location;
  return window.encodeURIComponent?.(origin);
};

export const getOriginWithoutPort = () => {
  const url = new URL(window.location.origin);
  url.port = '';
  return url.origin;
};

export const getUrlTokenFromUlpPage = (ulpOrigin: string) =>
  `${ulpOrigin}${LOCAL_API}?url=${getEncodedUrl()}&for_lane=true`;

export const createIframeSrc = ({
  ulpOrigin,
  env,
  authUrl,
  needGetUlpToken,
  loginPath = '',
}: Options): string => {
  // 自定义接口鉴权场景
  // 先跳转到ulp: sso-local-dev页面,获取到ulp的cookie;
  // SDK将cookie写在当前域名下;
  // 泳道后端获取到ulp cookie, 调用ulp sso接口;

  if (needGetUlpToken) {
    return getUrlTokenFromUlpPage(ulpOrigin);
  }
  // const isLocalEnv = env === 'local';
  // const isLaneEnv = env === 'lane';
  // const targetEnv = isLaneEnv ? 'test' : env;
  // const isProxy =
  //   isLocalEnv &&
  //   !localList.find((item) => window.location.origin.includes(item));
  // const origin = getOriginWithoutPort();
  const { origin } = window.location;

  // const encodedLoginPath = window.encodeURIComponent?.(origin);

  // 泳道只有测试环境;
  // 主对子的情况

  // if (isProxy) {
  //   return `${testOrigin}${LOCAL_API}?url=${encodedLoginPath}&for_lane=${isLaneEnv}`;
  // }

  const originWithApi = authUrl ?? `${ulpOrigin}${ULP_API}`;

  const selectedEnv = env ?? getEnv(ulpOrigin) ?? 'prod';

  // return `${selectedOrigin}${ULP_API}?env=${selectedEnv}&url=${origin}&token=${null}`;
  return `${originWithApi}?env=${selectedEnv}&url=${origin + loginPath}&token=${null}`;
};
